import { Result } from 'antd'
import Loader from 'Common/Loader'
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary } from 'devextreme-react/cjs/data-grid'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import CustomStore from 'devextreme/data/custom_store'
import moment from 'moment'
import { GetBirthdayAndAnniversaryCustomersByMonth } from './services/BirthdayAndAniverssery.services'

const BirthdayAndAniverssary = () => {
    const [loading, setLoading] = useState(false)
    const [permissionDetails, setPermissionDetails] = useState<string[]>([]);

    useEffect(() => {
        const authUserString = localStorage.getItem("authPOSUser");
        if (authUserString) {
            const authUser = JSON.parse(authUserString);
            const permissionData = authUser?.permissions || [];
            setPermissionDetails(permissionData);
        }
    }, []);

    const HasPermission = (permission: string): boolean => {
        return permissionDetails.includes(permission);
    };

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const { searchValue, skip, take } = loadOptions;
                    const parameterList = new URLSearchParams();
                    if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                    if (typeof take === 'number') parameterList.append('take', take.toString());
                  
                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }
                    const response = await GetBirthdayAndAnniversaryCustomersByMonth(parameterList);

                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }

    const formatDateToIST = (utcDateString: string): string => {
        if (!utcDateString) return "";
        // Ensure it's parsed as UTC
        const date = new Date(utcDateString + "Z");
        return new Intl.DateTimeFormat("en-IN", {
            timeZone: "Asia/Kolkata", // Force IST
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // 12h format with AM/PM
        })
            .format(date)
            .replace(",", ""); // remove comma for clean look
    };
    return (
        <>
            {loading && <Loader />}
            <div className="page-content">
                <div className="container-fluid">

                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Birthday and Anniversary</h5>
                        </Card.Header>
                        <Card.Body className='pt-0'>
                            <DataGrid
                                dataSource={dataSource()}
                                showRowLines={true}
                                keyExpr="id"
                                showBorders={true}
                                columnAutoWidth={true}
                                remoteOperations={{
                                    paging: true,
                                    sorting: true,
                                    filtering: true
                                }}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                                onCellPrepared={(e) => {
                                    if (["data", "header"].includes(e.rowType)) {
                                        e.cellElement.style.textAlign = "center";
                                    }
                                }}
                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <Paging defaultPageSize={10} />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}

                                />
                                <SearchPanel visible={true} width={240} placeholder="Search..." />


                                <Column dataField="id" caption="id" dataType="string" visible={false} allowFiltering={false} />
                                <Column dataField="name" caption="Customer Name" dataType="string" />
                                <Column dataField="mobileNo" caption="Mobile No." dataType="number" />
                                <Column
                                    dataField="birthday"
                                    caption="Birthday Date"
                                    dataType="date"
                                    format="dd/MM/yyyy"
                                />
                                <Column
                                    dataField="anniversary"
                                    caption="Anniversary Date"
                                    dataType="date"
                                    format="dd/MM/yyyy"
                                />
                                <Column
                                    dataField="lastPurchaseDate"
                                    caption="Last Purchase Date"
                                    dataType="string"
                                    calculateDisplayValue={(rowData) => formatDateToIST(rowData.lastPurchaseDate)}
                                />
                                <Column dataField="rewardPointBalance" caption="Reward Point Balance" dataType="number" />
                            </DataGrid>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </>
    )
}

export default BirthdayAndAniverssary
